<template>
  <div class="welfare-bind">
    <div class="figure"></div>
    <div class="bind-title"><AutoFontSize v-if="isShow">{{ $t('welfare_bind_title') }}</AutoFontSize></div>
    <div class="content">
      <div class="line line-1"><AutoFontSize v-if="isShow">{{ $t('welfare_bind_tips_1') }}</AutoFontSize></div>
      <div class="line line-2">{{ $t('welfare_bind_tips_2') }}</div>
      <div class="award"></div>
      <div class="btn" @click="onBtnBindClick">{{ $t('welfare_bind_btn') }}</div>
      <div class="complete" v-if="isComplete"></div>
      <div class="rules">* {{ $t('WEB_only_tips') }}</div>
    </div>
    <i18n path="text_privacy_tips" tag="div" class="tips">
      <span :slot="0" @click="seePrivacy">{{ $t('text_privacy') }}</span>
    </i18n>
  </div>
</template>

<script>
import { ameApiHold } from '@/server/api'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'BindAccount',
  props: ['isShow'],
  data () {
    return {
      isComplete: false
    }
  },
  created () {
    this.init()
    this.$bus.$on('welfare-check-ame-bind', () => {
      this.init()
    })
  },
  computed: {
    ...mapGetters(['bindAccountNum']),
    ...mapState({
      bindInfo: 'bindInfo',
      userInfo: 'userInfo'
    })
  },
  methods: {
    init () {
      const params = {
        p0: 'web',
        p1: this.$ENUM.AME_PROJECT_ID,
        p2: this.$ENUM.AME_EVENT_MAP.BIND_ACCOUNT,
        openid: this.userInfo.openid
      }
      ameApiHold(params)
        .then(res => {
          if (res && res.length) {
            this.isComplete = true
            this.$emit('setDot', false)
          } else {
            this.$emit('setDot', true)
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    seePrivacy () {
      window.open('https://funplus.com/privacy-policy/', '_blank')
    },
    onBtnBindClick () {
      localStorage.setItem('log-bind-entry', 'reward_center')
      this.$bus.$emit('welfare-events', 'bindAccount')
      this.$utils.log('bind_account', { bind_channel: 'reward_center' })
    }
  },
  beforeDestroy () {
    this.$bus.$off('welfare-check-ame-bind')
  }
}
</script>

<style lang='scss' scoped >
.welfare-bind {
  width: calc(1259 * var(--unit-px));
  height: calc(660 * var(--unit-px));
  background: url(~@/assets/img/welfare/bg_bind.jpg) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  margin-left: calc(158 * var(--unit-px));
  margin-top: calc(124 * var(--unit-px));
}
.figure {
  width: calc(693 * var(--unit-px));
  height: calc(812 * var(--unit-px));
  position: absolute;
  bottom: calc(-28 * var(--unit-px));
  left: calc(-174 * var(--unit-px));
  z-index: 1;
  background: url(~@/assets/img/welfare/bg_bind_2.png) no-repeat center center;
  background-size: 100% 100%;
}
.bind-title {
  position: absolute;
  z-index: 2;
  top: calc(-117 * var(--unit-px));
  left: calc(-114 * var(--unit-px));
  right: calc(60 * var(--unit-px));
  text-align: right;
  font-size: calc(60 * var(--unit-px));
  font-weight: bold;
  .auto-font-size {
    text-align: right;
  }
  ::v-deep(span) {
    color: #F0D7A2;
    line-height: 1.4;
    background: linear-gradient(180deg, #FCF5DC 0%, #E4C78A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.content {
  position: absolute;
  z-index: 3;
  top: calc(40 * var(--unit-px));
  right: calc(60 * var(--unit-px));
  width: calc(746 * var(--unit-px));
  height: calc(625 * var(--unit-px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  div {
    flex-shrink: 0;
  }
  .line {
    text-align: right;
    font-size: calc(30 * var(--unit-px));
    line-height: 1.44;
    font-weight: bold;
    color: #391D1E;
  }
  .line-2 {
    height: calc(58 * var(--unit-px));
    position: relative;
  }
  .award {
    width: calc(575 * var(--unit-px));
    height: calc(244 * var(--unit-px));
    background: url(~@/assets/img/welfare/award_bind.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(82 * var(--unit-px));
    margin-right: calc(60 * var(--unit-px));
  }
  .btn {
    width: calc(746 * var(--unit-px));
    height: calc(117 * var(--unit-px));
    background: url(~@/assets/img/welfare/bg_btn.png) no-repeat center center;
    background-size: 100% 100%;
    margin-top: calc(26 * var(--unit-px));
    cursor: pointer;
    line-height: calc(117 * var(--unit-px));
    text-align: center;
    font-size: calc(44 * var(--unit-px));
    font-weight: 600;
    color: #473232;
  }
  .complete {
    position: absolute;
    width: calc(349 * var(--unit-px));
    height: calc(264 * var(--unit-px));
    background: url(~@/assets/img/welfare/icon_complete.png) no-repeat center center;
    background-size: 100% 100%;
    bottom: calc(8 * var(--unit-px));
    right: calc(-94 * var(--unit-px));
  }
  .rules {
    position: absolute;
    z-index: 3;
    right: 0;
    bottom: calc(18 * var(--unit-px));
    font-size: calc(24 * var(--unit-px));
    font-weight: 400;
    color: #FFFFFF;
    line-height: 1;
    text-shadow: 0px 2px 2px rgba(0,0,0,0.74);
  }
}
.tips {
  text-align: right;
  position: absolute;
  line-height: 1;
  top: 100%;
  right: 0;
  font-size: calc(24 * var(--unit-px));
  color: #FFFFFF;
  margin-top: 1em;
  span {
    cursor: pointer;
    color: rgba(255, 94, 15, 1);
  }
}
</style>
